import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import LanguageIcon from "@mui/icons-material/Language";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
// import Viewimage from "../../../../../api/Viewimage";
import Paper from "@mui/material/Paper";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import Viewimage from "../../../../api/Viewimage";
const ApplicationViewDetails = ({ details, detail }) => {
    const [open, setOpen] = useState(false);
    const [viewImage, setViewImage] = useState("");
    const handleClickOpen = (value) => {
        setViewImage(value);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const [value, setValue] = React.useState("1");
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <>
            <main>
                <section>
                    <div className="">
                        <h4
                            className="font-weight-bold my-4"
                            style={{ fontFamily: "Inter, sans-serif" }}
                        >
                            Personal Information
                        </h4>
                        <div className="row">

                            <div className="col-lg-4">
                                <p className="mt-4">
                                    <b>Sector :</b>
                                </p>
                                <p>{details.sector}</p>
                            </div>
                            <div className="col-lg-4">
                                <p className="mt-4">
                                    <b>WebSite :</b>
                                </p>
                                <p>{details.website}</p>
                            </div>
                            <div className="col-lg-4">
                                <p className="mt-4">
                                    <b>Support required from StartupTN :</b>
                                </p>
                                <p>{details.support}</p>
                            </div>
                            <div className="col-lg-4">
                                <p className="mt-4">
                                    <b>DPIIT Registration Number & Certificate :</b>
                                </p>
                                <p className="doc-flex">
                                    {details.dpiitRegNumber ? (
                                        <span>
                                            {details.dpiitRegNumber}
                                            {details.dpiitCertificateName && (
                                                <span className="ml-3">
                                                    <span
                                                        className="viewdoc1"
                                                        onClick={() =>
                                                            handleClickOpen(details.dpiitCertificateName)
                                                        }
                                                    >
                                                        View Document
                                                    </span>
                                                </span>
                                            )}
                                        </span>
                                    ) : (
                                        <span style={{ color: "red" }}>Document NA</span>
                                    )}
                                </p>


                            </div>
                            <div className="col-lg-4">
                                <p className="mt-4">
                                    <b>City :</b>
                                </p>
                                <p>{details.city}</p>
                            </div>
                            <div className="col-lg-4">
                                <p className="mt-4">
                                    <b>State :</b>
                                </p>
                                <p>{details.state}</p>
                            </div>
                            <div className="col-lg-4">
                                <p className="mt-4">
                                    <b>Country :</b>
                                </p>
                                <p>{details.country}</p>
                            </div>
                        </div>
                        <h6
                            className="font-weight-bold my-4"
                            style={{ fontFamily: "Inter, sans-serif" }}
                        >
                            Brief Description of your Startup :
                        </h6>
                        <p className="mt-4">{details.briefStartupDescription}</p>


                    </div>
                </section>
            </main>
            <Viewimage viewImage={viewImage} open={open} handleClose={handleClose} />
        </>
    );
};

export default ApplicationViewDetails;
